<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-title">
                    <el-form id="elForm" :inline="true" :model="formInline" ref="formInline" label-width="85px" label-position="right" class="demo-form-inline" size="medium">
                      <el-form-item label="市：" prop="cityID" v-show="show.selCity">
                        <el-select v-model="formInline.cityID" placeholder="请选择市" @change="selectChange(1,formInline.cityID)">
                            <el-option v-for="item in selectcity" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="区县：" prop="countryID" v-show="show.selCountry">
                        <el-select v-model="formInline.countryID" placeholder="请选择区" @change="selectChange(2,formInline.countryID)">
                            <el-option v-for="item in selectarea" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="幼儿园：" prop="gardenId">
                          <el-select v-model="formInline.gardenId" filterable placeholder="请选择幼儿园">
                              <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="姓名：" prop="teacherName">
                          <el-input v-model="formInline.teacherName" placeholder="请输入姓名"></el-input>
                      </el-form-item>
                      <el-form-item label="性别：" prop="teacherSex">
                          <el-select v-model="formInline.teacherSex" placeholder="请选择性别">
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option key="1" label="男" value="1"></el-option>
                            <el-option key="2" label="女" value="2"></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item label="生日：" prop="birDate">
                          <el-date-picker v-model="birDate" type="daterange" align="right" @change="changeBir" placeholder="选择日期范围" :picker-options="pickerOptions"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="体检日期：" prop="phyDate">
                          <el-date-picker v-model="phyDate" type="daterange" align="right" @change="changePhy" placeholder="选择日期范围" :picker-options="pickerOptions"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="下发：" prop="isIssuedStatus">
                        <el-select v-model="formInline.isIssuedStatus" placeholder="请选择下发">
                          <el-option key="" label="全部" value=""></el-option>
                          <el-option key="1" label="已下发" value="1"></el-option>
                          <el-option key="2" label="未下发" value="2"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                          <el-button class="btn-primary" @click="onSubmit(formInline)">查询</el-button>
                          <el-button class="btn-default" @click="onReset('formInline')">重置</el-button>
                      </el-form-item>
                    </el-form>
                    <div class="mb15">
                      <!-- <el-button @click="AddTo()"><i class="el-icon-edit"></i>&nbsp;添加</el-button>
                      <el-button @click="removegGarten()"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                      <el-button @click="Issued()"><i class="el-icon-sold-out"></i>&nbsp;下发</el-button>
                      <el-button @click="imports()"><i class="el-icon-upload"></i>&nbsp;导入</el-button> -->
                       <el-button v-for='(item,index) in generalArea' :key='index' class="btn-outline" @click="doClick(item.operFunc)"  plain>{{item.operName}}</el-button>
                    </div>
                    <el-table ref="multipleTable" id="tableList" class="table-bordered" :data="tableData" @select="tableSelect" @select-all="tableSelectAll" v-loading="tableLoading" element-loading-text="拼命加载中" bordertooltip-effect="dark" style="width: 100%">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="teacherName" label="姓名"></el-table-column>
                        <el-table-column prop="teacherSex" label="性别"></el-table-column>
                        <el-table-column prop="teacherBirthday" label="生日" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="gardenName" label="幼儿园" show-overflow-tooltip> </el-table-column>
                        <el-table-column prop="checkDate" label="体检日期" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="checkResult" label="检查结果" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="doctorSuggestion" label="医生意见" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="isIssuedStr" label="下发" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width='170'>
                          <template slot-scope="scope">
                              <!-- <el-button class="btn-primary btn-outline" @click="editAccount(scope.$index,scope.row)" size="small" plain><i class="el-icon-edit-outline"></i>修改</el-button>
                              <el-button class="btn-warning btn-outline" @click="orgmgrDel(scope.$index,scope.row)" size="small" plain><i class="el-icon-document"></i>详情</el-button> -->
                              <el-button v-for='(item,index) in listArea' :key='index' class="btn-outline" @click="doClick(item.operFunc,scope.$index,scope.row)" size="small" plain>{{item.operName}}</el-button>
                          </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-sizes="[10, 25, 50, 100]" :page-size="formInline.pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total" style="margin-top: 10px;">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--彈出的添加-->
      <el-dialog title="" :visible.sync="dialogTableVisible" :width="width" min-width="500px" :before-close="handleClose" :close-on-click-modal='false'>
        <router-view v-on:close="close" v-if='dialogTableVisible'></router-view>
      </el-dialog>
  </div>
</template>
<script>
import {MessageBox, Loading} from 'element-ui'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import common from '../../com/common'
export default {
  name: '',
  data () {
    var that = this
    return {
      dialogTableVisible: false,
      tableData: [], // 数据表数据
      tableSelection: [], // 数据表选择数据集合
      tableSelectObj: {}, // 数据表单条选择数据对象
      tableSelectKey: '',
      tableLoading: false,
      birDate: '',
      phyDate: '',
      isPushed: '',
      checkResult: '',
      isIssued: '',
      width: '70%',
      formInline: {// 筛选条件表单数据
        gardenId: '',
        pageNum: 1,
        pageSize: 10,
        isIssuedStatus: '',
        teacherName: '',
        teacherSex: '',
        id: '',
        provinceID: '',
        countryID: '',
        cityID: ''
      },
      show: {
        selCountry: false,
        selCity: false
      },
      queryParam: {},
      itemResultList: [],
      selectpro: [], // 筛选条件下拉框省数据
      selectcity: [], // 筛选条件下拉框市数据
      selectarea: [], // 筛选条件下拉框区数据
      selectGarden: [{orgKindID: '', fullName: '全部'}], // 筛选条件下拉框幼儿园数据
      total: 0,
      pickerOptions: {
        shortcuts: [
        //   {
        //   text: '全部',
        //   onClick (picker) {
        //     const end = this.queryParam.endDate
        //     const start = this.queryParam.startDate
        //     picker.$emit('pick', [start, end])
        //   }
        // },
          {
            text: '过去七天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去30天',
            onClick (picker) {
              const end = new Date()
              const start = that.GetMonthStr(1)
            //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去半年',
            onClick (picker) {
              const end = new Date()
              const start = that.GetMonthStr(6)
            //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '过去一年',
            onClick (picker) {
              const end = new Date()
              const start = that.GetMonthStr(12)
              picker.$emit('pick', [start, end])
            }
          }]
      },
      generalArea:[],
      listArea:[]
    }
  },
  methods: {
    handleClose () {
      let that = this
      that.dialogTableVisible = false
      that.dialogTable = false
    },
    // 判断 月
    GetMonthStr (AddMonthCount) { // 获取过去几个月
      var dd = new Date()
      dd.setMonth(dd.getMonth() - AddMonthCount)// 获取AddMonthCount月后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1// 获取当前月份的日期
      var d = dd.getDate()
      // 判断 月
      if (m < 10) {
        m = '0' + m
      }
      // 判断 日n
      if (d < 10) { // 如果天数<10
        d = '0' + d
      }
      return y + '-' + m + '-' + d
    },
    selectChange (sel, parentID) { // 下拉框值改变事件
      var self = this
      if (sel === 1) { // 市
        self.selectarea = [{id: '', name: '全部'}]
        self.formInline.countryID = ''
        if (parentID !== '') {
          self.getList(config.host + 'common/getAreasList.do', { 'parentID': parentID }, 'selectarea')
        }
        self.formInline.gardenId = ''
        self.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: self.formInline.provinceID, // 必须
          cityID: parentID,
          countryID: ''}, 'selectGarden', true)
      } else {
        self.formInline.gardenId = ''
        self.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: self.formInline.provinceID, // 必须
          cityID: self.formInline.cityID,
          countryID: self.formInline.countryID}, 'selectGarden', true)
      }
    },
    getList (url, param, key, isOrg) {
      var that = this
      that[key + ''] = []
      api.post(url, param).then(function (response) {
        that[key + ''] = response.body.list
        if (isOrg) {
          that[key + ''].splice(0, 0, {orgKindID: '', fullName: '全部'})
        } else {
          that[key + ''].splice(0, 0, {id: '', name: '全部'})
        }
      })
    },
    close (flag, refresh) {
      this.dialogTableVisible = flag
      if (refresh === true) {
        this.getOrgList(this.formInline)
      }
    },
    tableSelect (selection, val) { // 表格选中事件
      this.tableSelection = selection
      this.tableSelectObj = val
    },
    tableSelectAll (selection) {
      this.tableSelection = selection
    },
    onSubmit (pram) { // 查询条件查询按钮点击事件
      // this.formInline.pageSize = 10;
      pram.pageNum = 1;
      this.getOrgList(pram)
    },
    onReset (formName) { // 查询条件重置
      this.$refs[formName].resetFields()
      this.birDate = ''
      this.formInline.birthdayStart = ''
      this.formInline.birthdayEnd = ''
      this.phyDate = ''
      this.formInline.startDate = ''
      this.formInline.endDate = ''
    },
    exportUser () { // 导入
      this.$router.push({ path: 'user_mgr_export' })
    },
    removegGarten () { // 删除
      if (this.tableSelection.length === 0) {
        this.showMsgTip('错误！您没有选择任何数据', 'false')
      } else {
        this.$confirm('您确定要删除所选择的体检数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.operation()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    operation () { // 删除
      var result = ''
      var that = this
      that.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.id
        } else {
          result = result + ',' + i.id
        }
      })
      var nparm = {
        'mecInfoIds': result
      }
      api.post(config.host + 'staffMec/deleteStaffMECInfo.do', nparm).then(function (response) {
        if (response.success === true) {
          that.$message.success('操作成功')// 提示用户
          that.getOrgList(that.formInline)
        }
      })
    },
    Issued () { // 下发
      if (this.tableSelection.length === 0) {
        this.showMsgTip('错误！您没有选择任何数据', 'false')
      } else {
        this.$confirm('您确定要把所选择的体检数据下发给幼儿园吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.IssuedFun()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下发'
          })
        })
      }
    },
    IssuedFun () { // 下发
      var result = ''
      var self = this
      this.tableSelection.forEach(function (i) {
        if (result === '') {
          result = i.id
        } else {
          result = result + ',' + i.id
        }
      })
      var nparm = {
        'mecInfoIds': result
      }
      api.post(config.host + 'staffMec/updateIssuedStatus.do', nparm).then(function (response) {
        if (response.success === true) {
          self.showMsgTip(response.msg, true)
          self.onSubmit(self.formInline)
        }
      })
    },
    AddTo (url) {
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({ path: '/teacherPhy/add' })
      this.dialogTable = true
    },
    editAccount (index, row) { // 修改
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({path: '/teacherPhy/edit/' + row.id})
      this.dialogTable = true
    },
    orgmgrDel (index, row) { // 详情
      this.width = '70%'
      this.dialogTableVisible = true
      this.$router.push({path: '/teacherPhy/detail/' + row.id})
      this.dialogTable = true
    },
    showMsgTip (value, type) { // 提示消息
      if (type === 'false') {
        this.$message({
          message: value
        })
      } else {
        this.$message({
          message: value,
          type: type
        })
      }
    },
    imports () { // 导入
      this.width = '600px'
      this.dialogTableVisible = true
      this.$router.push({ path: '/teacherPhy/import/' })
      this.dialogTable = true
    },
    handleSizeChange (val) { // 分页每页条数改变事件
      this.formInline.pageSize = val
      this.getOrgList(this.formInline)
    },
    handleCurrentChange (val) { // 分页页数改变事件
      this.formInline.pageNum = val
      this.getOrgList(this.formInline)
    },
    changeBir (val) {
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
        this.formInline.birthdayStart = startYouWant
        this.formInline.birthdayEnd = endYouWant
      } else {
        this.formInline.birthdayStart = ''
        this.formInline.birthdayEnd = ''
      }
    },
    changePhy (val) {
      if (val) {
        var d = new Date(val[0])
        var b = new Date(val[1])
        var startYouWant = d.getFullYear() + '-' + this.getDateN(d.getMonth() + 1) + '-' + this.getDateN(d.getDate())
        var endYouWant = b.getFullYear() + '-' + this.getDateN(b.getMonth() + 1) + '-' + this.getDateN(b.getDate())
        this.formInline.startDate = startYouWant
        this.formInline.endDate = endYouWant
      } else {
        this.formInline.startDate = ''
        this.formInline.endDate = ''
      }
    },
    getDateN (date) {
      date = (date < 10) ? (date = '0' + date) : date
      return date
    },
    getOrgList (pram) { // 获取表格数据
      var that = this
      api.post(config.host + 'staffMec/getStaffMECInfoList.do', pram).then(function (response) {
        if (response.success === true) {
          that.tableData = response.body.list
          that.total = response.body.page.total
          that.tableSelection = [] // 数据表选择数据集合
          that.tableSelectObj = {} // 数据表单条选择数据对象
        }
      })
    },
    doClick(operFunc,index,row){
      switch(operFunc){
       case 'doModify':this.editAccount(index,row);break
       case 'showDetail':this.orgmgrDel(index,row);break
       case 'doDelelte':this.removegGarten();break
       case 'doAdd':this.AddTo();break
       case 'doImport':this.imports();break
       case 'doIssue':this.Issued();break
      }
    }
  },
  created () {
    var that = this
    api.post(config.host + 'org/getOrgDetailWithDefault.do').then(function (json) {
      var orgInfo = json.body.orgInfo
      if (orgInfo.scopeType === 1) { // 省级
        that.show.selCity = true
        that.show.selCountry = true
        that.selectarea = [{id: '', name: '全部'}]
        that.getList(config.host + 'common/getAreasList.do', { 'parentID': orgInfo.provinceID }, 'selectcity')
        that.getList(config.host + 'orgkind/getOrgKindListByArea.do', {provinceID: orgInfo.provinceID}, 'selectGarden', true)
      } else if (orgInfo.scopeType === 2) { // 市级
        that.show.selCountry = true
        that.formInline.cityID = orgInfo.cityID
        that.getList(config.host + 'common/getAreasList.do', { 'parentID': orgInfo.cityID }, 'selectarea')
        that.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: orgInfo.provinceID, // 必须
          cityID: orgInfo.cityID}, 'selectGarden', true)
      } else if (orgInfo.scopeType === 3) { // 区县级
        that.formInline.cityID = orgInfo.cityID
        that.formInline.countryID = orgInfo.countryID
        that.getList(config.host + 'orgkind/getOrgKindListByArea.do', { provinceID: orgInfo.provinceID, // 必须
          cityID: orgInfo.cityID,
          countryID: orgInfo.countryID}, 'selectGarden', true)
      } else {
        that.getList(config.host + 'orgkind/getOrgKindListByArea.do', {}, 'selectGarden', true)
      }
      that.formInline.provinceID = orgInfo.provinceID
      that.getOrgList(that.formInline)
    })
  },
  mounted(){
    let btnList = window.paramFromParent
    btnList = common.getBtnList(btnList)
    this.generalArea = btnList.generalArea
    this.listArea = btnList.listArea
  }
}
</script>

<style scoped>
.ml15 {
    margin-left: 15px;
}
#tableList .el-table .cell, .el-table th>div{
    padding-left: 0;
    padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/physical/teacherPhy.vue?c2fa79d0